export enum ServiceItemType {
  Type,
  Volume,
}

export const ListOfServiceItemType = [
  { label: "نوع", value: ServiceItemType.Type },
  { label: "حجم", value: ServiceItemType.Volume },
];
